import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'
import { v4 } from 'uuid'
import Topbar from '../Topbar/';
import JitsuLoader from '../JitsuLoader/';

import Button from '@material-ui/core/Button';

import TextField from '@material-ui/core/TextField';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import { makeContactRequest } from './actions'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';

const theme = createMuiTheme({
  palette: {
    type: 'dark',
  },
});

class AddContactComponet extends Component {
  constructor() {
    super();
    this.state = {
      contactInfo: "",
      showDialog: false,
    }
  }

  pressEnter = (event) => {

    if (event.keyCode == 13) {
      this.props.makeContactRequest(this.state.contactInfo)
    }

  }

  makeContactRequest = () => {

    var {user: {userProfile: {email}}} = this.props;

    if (email.toLowerCase() == this.state.contactInfo.toLowerCase()) {

      this.setState({
        showDialog: true,
        dialogMsg: "If you understand yourself you are illuminated",
        contactInfo: "",
      })

      return;

    }

    if (this.state.contactInfo && this.state.contactInfo.length > 0) {

      this.setState({
        showLoader: true
      })

      this.props.makeContactRequest(this.state.contactInfo)

        .then(makeContactResponse => {
          this.setState({
            showLoader: false,
          })
          console.log('makeContactResponse', makeContactResponse)

          var {emailResponse, msg} = makeContactResponse;

          if (emailResponse) {

            this.setState({
              showDialog: true,
              dialogMsg: "contact request sent!",
              contactInfo: "",
            })
          } else if (msg) {

            this.setState({
              showDialog: true,
              dialogMsg: msg,

            })

          }

        })

    }
  }

  handleClose = () => {

    this.setState({
      showDialog: false,
      dialogMsg: "msg"

    })
  }

  render() {

    return (
      <div style={ { backgroundColor: 'black' } } className="h-100 d-flex flex-column">
        <Topbar/>
        <div className="flex-1 scroll-y">
          <br/>
          <br/>
          <MuiThemeProvider theme={ theme }>
            <Card>
              <CardContent>
                <Button onClick={ () => window.location.hash = "conversations" } variant="contained" color="primary">
                  Back To Conversations
                </Button>
                <TextField onKeyUp={ (event) => this.pressEnter(event) } value={ this.state.contactInfo } label={ `Enter Email or Phone Number` } onChange={ event => this.setState({
                                                                                                                                                               contactInfo: event.target.value
                                                                                                                                                             }) } InputLabelProps={ { shrink: true } }
                  placeholder="Enter Contact Info ..." fullWidth margin="normal" />
                <div className="d-flex flex-column align-items-center w-100">
                  <Button onClick={ () => this.makeContactRequest() } variant="contained" color="primary">
                    Add Contact
                  </Button>
                  <br/>
                </div>
              </CardContent>
            </Card>
          </MuiThemeProvider>
        </div>
        { this.state.showDialog && <Dialog open={ this.state.showDialog } onClose={ this.handleClose } aria-labelledby="simple-dialog-title">
                                     <Card>
                                       <CardContent style={ { height: 300, width: 300, textAlign: 'center' } } className='d-flex justify-content-center align-items-center'>
                                         <span style={ { fontFamily: 'Gloria Hallelujah', fontSize: '6vh', color: 'purple', position: 'relative', zIndex: 10 } }>{ this.state.dialogMsg }</span>
                                         <div style={ { top: .5, position: 'absolute', zIndex: 1 } } className='h-100 d-flex justify-content-center align-items-center'>
                                           <img style={ { opacity: .3 } } className="h-100" src={ "./images/pureyang.png" } alt="" />
                                         </div>
                                       </CardContent>
                                     </Card>
                                   </Dialog> }
        { this.state.showLoader && <JitsuLoader/> }
      </div>

      );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
})

const AddContact = connect(mapStateToProps, {
  makeContactRequest
})(AddContactComponet)

export default AddContact


// WEBPACK FOOTER //
// ./src/Components/AddContactPage/index.js